import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import InputStructureComponent from '../components/InputStructureComponent';
import IAppState from '../../../IAppState';
import {
    IInputStructureComponentPropsData,
    IInputStructureComponentPropsFunctions,
} from '../props/IInputStructureComponentProps';
import ActMain from '../../../act-main';
import ActSummary from '../../SummaryPage/state/act-summary';
import { clientUrlPrefix } from '../../../settings';
import IDT from '../interfaces/InputDataType';
import ATE from '../../../ActionTypeEnum';
import { ll_fetch } from '../../../tools';
import axios from 'axios';
import { ll_url } from '../../../tools';
import IMainState from '../../../IMainState';

function submitInput(dispatch: any, browserHistory: any) {
    dispatch(ActSummary.submitInput());

    browserHistory.push(clientUrlPrefix + '/job-settings');
}

interface IOwnProps {
    ecNumber?: string;
    choice;
    customQuery?: boolean;
    history: any;
}

async function structureFromID(dispatch: any, pdbId: string, jobId: string) {
    
    dispatch({
        type: ATE.SET_WAITING_PDB,
        value: true
    });

    if (jobId == '') {
        try {
            const response = await ll_fetch(`/api/pdb/getJobId?jobId=`);
            jobId = await response.text();
            dispatch({
                type: ATE.SET_JOB_ID,
                value: jobId,
            });
        } catch (err) {
            console.log('FAILED TO GET JOB ID');
            console.error(err);
        }
    }

    var biounitError = false;
    var chainsError = false;
    var unknownAAs = false;
    await ll_fetch(`/api/pdb/processPdbId?pdbId=${pdbId}&jobId=${jobId}`)
        .then((response) => response.json())
        .then((data) => {
                console.log(data)
                unknownAAs = data.unknownAAs
                dispatch({
                    type: ATE.CHANGE_STRUCTURE_INFO,
                    value: data,
                })
            }
        )
        .catch((err) => {
            console.log('FAILED TO GET BIOLOGICAL UNITS');
            console.error(err);
            biounitError = true;
        });

    await ll_fetch(`/api/pdb/getChains?jobId=${jobId}`)
        .then((response) => response.json())
        .then((data) =>
            dispatch({
                type: ATE.OBTAIN_CHAINS,
                value: data,
            })
        )
        .catch((err) => {
            console.log("Unable to obtain chains");
            console.error(err);
            chainsError = true;
        });


        dispatch({
            type: ATE.SET_WAITING_PDB,
            value: false
        });
        if(unknownAAs){
            alert("PDB contains non-standard amino-acids. We cannot process this PDB.");
            dispatch(ActMain.setShowChainsSelection(false));
        }
        else if(!biounitError && !chainsError){
            dispatch(ActMain.setShowChainsSelection(true));  
        }
        else if(biounitError && !chainsError){
            alert("We were unable to obtain biological units. Please select the chains manually.");
            dispatch(ActMain.setShowChainsSelection(true));
        }
        else if(biounitError && chainsError){
            alert("We were unable to process your PDB ID.");
        }
        else{
            alert("Unknown error occured during the PDB download step.");
        }
}

async function handlePdbFile(dispatch: any, pdbFile: File, jobId: string) {
    //check if job has assigned jobID

    dispatch({
        type: ATE.SET_WAITING_PDB,
        value: true
    });

    if (jobId == '') {
        try {
            const response = await ll_fetch(`/api/pdb/getJobId?jobId=`);
            jobId = await response.text();
            dispatch({
                type: ATE.SET_JOB_ID,
                value: jobId,
            });
        } catch (err) {
            console.log('FAILED TO GET JOB ID');
            console.error(err);
        }
    }

    // =======
    // uploading structure

    let formData = new FormData();
    //Adding files to the formdata
    console.log(pdbFile);
    formData.append('file', pdbFile);
    //formData.append("name", "Name");

    await axios({
        // Endpoint to send files
        url: ll_url('') + `/api/inputFile/uploadStructure?jobId=${jobId}`,
        method: 'POST',
        headers: {
            //authorization: "your token comes here",
        },
        // Attaching the form data
        data: formData,
    })
        .then((res) => {}) // Handle the response from backend here
        .catch((err) => {
        }); // Catch errors if any

    // =======
    // getting biological units

    var biounitError = false;
    var chainsError = false;
    var unknownAAs = false;
    await ll_fetch(`/api/pdb/processPdbStructure?jobId=${jobId}`)
        .then((response) => response.json())
        .then((data) => {
                console.log(data)
                unknownAAs = data.unknownAAs
                dispatch({
                    type: ATE.CHANGE_STRUCTURE_INFO,
                    value: data,
                })
            }
        )
        .catch((err) => {
            biounitError = true;
            console.log('FAILED TO GET BIOLOGICAL UNITS');
            console.error(err);
        });

    await ll_fetch(`/api/pdb/getChains?jobId=${jobId}`)
        .then((response) => response.json())
        .then((data) =>
            dispatch({
                type: ATE.OBTAIN_CHAINS,
                value: data,
            })
        )
        .catch((err) => {
            chainsError = true;
            console.log("Unable to obtain chains");
            console.error(err);
        })
    
    dispatch({
            type: ATE.SET_WAITING_PDB,
            value: false
    });
   if(unknownAAs){
        alert("PDB contains non-standard amino-acids. We cannot process this PDB.");
        dispatch(ActMain.setShowChainsSelection(false));
    } else if(!biounitError && !chainsError){
        dispatch(ActMain.setShowChainsSelection(true));  
    }
    else if(biounitError && !chainsError){
        alert("We were unable to obtain biological units. Please select the chains manually.");
        dispatch(ActMain.setShowChainsSelection(true));
    }
    else if(biounitError && chainsError){
        alert("We were unable to process provided PDB file.");
    }
    else{
        alert("Unknown error occured during the PDB download step.");
    }
}

const mapStateToProps = (
    { mainState }: IAppState,
    ownProps: IOwnProps
): IInputStructureComponentPropsData => {
    return {
        pdbIdField: mainState.pdbIdField,
        jobId: mainState.jobId,
        selectedStructureInfo: mainState.selectedStructureInfo,

        specifyChainsManually: mainState.specifyChainsManually,
        chains: mainState.chains,
        selectedChains: mainState.selectedChains ?? [],
        showLoadingMsg: mainState.showWaitingPDB,
        showChainsSelection: mainState.showChainsSelection,
    };
};

const mapDispatchToProps = (
    dispatch: any,
    ownProps: IOwnProps
): IInputStructureComponentPropsFunctions => ({
    submitInput: () => submitInput(dispatch, ownProps.history),
    structureFromID: (pdbId: string, jobId: string) => structureFromID(dispatch, pdbId, jobId),
    handlePdbFile: (pdbFile: File, jobId: string) => handlePdbFile(dispatch, pdbFile, jobId),
    setSelectedStructureInfo: (selectedStructureInfo: IMainState['selectedStructureInfo']) => dispatch(ActMain.setSelectedStructureInfo(selectedStructureInfo)),

    setSpecifyChainsManually: (specifyChainsManually: boolean) => dispatch(ActMain.setMainState({ specifyChainsManually: specifyChainsManually })),
    setSelectedChains: (selectedChains: string[]) => dispatch(ActMain.setMainState({ selectedChains: selectedChains })),
    setShowChainsSelection: (showChainsSelection: boolean) => dispatch(ActMain.setShowChainsSelection(showChainsSelection)),
});

const InputStructureContainer = withRouter(
    connect(mapStateToProps, mapDispatchToProps)(InputStructureComponent)
);

export default InputStructureContainer;
